import color from 'atoms/colors/colors';

export const lightPalette = {
  background: {
    default: color.common.white,
    paper: color.common.white,
  },
  text: {
    primary: color.gray[900],
    secondary: color.gray[700],
  },
};

export const darkPalette = {
  background: {
    default: color.common.white,
    paper: color.common.white,
  },
  text: {
    primary: color.gray[900],
    secondary: color.gray[700],
  },
};

export const standardPalette = {
  ...color,
};
